import React, {useCallback} from 'react'

import {accountantService} from 'services'
import TableWithPageHeader from 'components/TableWithPageHeader'
import {invoicesColumns} from './columns'

const Detail = ({user, customer, filter}) => (
  <TableWithPageHeader
    descendant
    filter={filter}
    title='Invoices'
    subtitle={'Here you can find all invoices from ' + customer.email}
    columns={invoicesColumns}
    service={useCallback(
      (page, filter) => accountantService.getCustomerInvoices(user.accountantProfile.uuid, customer.uuidCustomer, user.accessToken, page, filter),
      [user, customer])}
    exportService
  />
)

export default Detail
